import { render, staticRenderFns } from "./BistrotBalance.vue?vue&type=template&id=a9684ab8"
import script from "./BistrotBalance.vue?vue&type=script&lang=js"
export * from "./BistrotBalance.vue?vue&type=script&lang=js"
import style0 from "./BistrotBalance.vue?vue&type=style&index=0&id=a9684ab8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports